<template>
  <div>
    <div class="top-box">
      <span>{{$t('modao')}}</span>
      <span class="modao-desc">{{$t('modaoDesc')}}</span>
    </div>
    
    <div class="content-container">
      <div class="difficult-box">
        <p :class="isEn ? 'en-desc-p' : ''" v-html="$t('difficultDesc')"></p>
        <div class="difficult-flex">

          <div v-for="(item, index) in difficultArray"
               :key="index"
               class="difficult-item"
               @mouseenter="difficultMouseEnter(index)"
               @mouseleave="difficultMouseLeave(index)">

               <img :src="item.src" />
               <span :class="isEn ? 'en-diff-title' : ''">{{$t(item.title)}}</span>

              <transition>
                <div class="description-box" 
                     v-show="difficultVisible[index]" 
                    >
                      <p v-for="(detail, index) in item.descArray" 
                        :key="index"
                        :class="isEn ? 'en-diff-detail' : 'desText'"
                        v-html="$t(detail)"
                        >
                      </p>
                </div>
              </transition>
          </div>
        </div>
      </div>

      <div class="advantage-box">
        <p class="serviceAdvantage">{{$t('serviceAdvantage')}}</p>
        <p :class="isEn ? 'en-service-desc-p' : 'serviceDesc'" v-html="$t('serviceDesc')"></p>
        <div class="advantage-flex">
          <div v-for="(item, index) in advantagesArray"
               :key="index"
               :class="isEn ? 'advantage-item en-item' : 'advantage-item'">

                <div class="item-left">
                  <img :src="item.src"/>
                  <span>{{$t(item.title)}}</span>
                </div>
                <div class="item-right">
                  <span :class="isEn ? 'en-item-desc' : ''">{{$t(item.des1)}}</span>
                  <span :class="isEn ? 'en-item-desc' : ''">{{$t(item.des2)}}</span>
                </div>
          </div>
        </div>
      </div>
    </div>

    <div class="apply-box">
      <span class="apply-use">{{$t('applyUse')}}</span>
      <span class="apply-desc">{{$t('beginService')}}</span>
      <el-button class="apply-btn" @click="jumpBusiness">{{$t('experienceNow')}}</el-button>
    </div>

    <fix-footer />

  </div>
</template>

<script>
import Footer from '@/components/Footer';

export default {

  data(){
    return{

      isEn: false,
      difficultVisible: [false, false, false],

      difficultArray:[
        {
          src: require('../assets/modao_luodi.png'),
          title: 'settleDifficult',
          descArray: [
            'settle1', 'settle2', 'settle3'
          ]
        },
        {
          src: require('../assets/modao_tech.png'),
          title: 'techDifficult',
          descArray: [
            'tech1', 'tech2', 'tech3'
          ]
        },
        {
          src: require('../assets/modao_run.png'),
          title: 'runDifficulr',
          descArray: [
            'run1', 'run2', 'run3'
          ]
        },
      ],

      advantagesArray: [
        {
          src: require('../assets/modao_settle.png'),
          title: 'fastSettle',
          des1: 'fastSettleDes1',
          des2: 'fastSettleDes2',
        },
        {
          src: require('../assets/modao_process.png'),
          title: 'systemMakeup',
          des1: 'systemMakeupDes1',
          des2: 'systemMakeupDes2',
        },
        {
          src: require('../assets/modao_output.png'),
          title: 'planOutput',
          des1: 'planOutputDes1',
          des2: 'planOutputDes2',
        },
        {
          src: require('../assets/modao_safety.png'),
          title: 'dataSafety',
          des1: 'dataSafetyDes1',
          des2: 'dataSafetyDes2',
        },
      ]
    }
  },

  created(){
    const locale = localStorage.getItem('locale');
    if(locale === 'zh'){
      this.isEn = false;
    }else{
      this.isEn = true;
    }
  },

  watch: {
    '$i18n.locale'(){
      const locale = localStorage.getItem('locale');
      if(locale === 'zh'){
        this.isEn = false;
      }else{
        this.isEn = true;
      }
    }
  },
  
  methods: {
    difficultMouseEnter(index){
      this.difficultVisible.splice(index, 1, true);
    },
    difficultMouseLeave(index){
      this.difficultVisible.splice(index, 1, false);
    },

    jumpBusiness(){
      this.$router.push('/business');
    }
  },
  
  components: {
    'fix-footer': Footer,
  }

}
</script>

<style lang="less" scoped>

.content-container{
  background-color: rgb(249, 249, 249);
  padding: 30px 280px;
}

.top-box{
  background: url('../assets/modao_bg.png') no-repeat center center;
  background-size: 100% 100%;
  height: 466px; /*px*/
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 60px 0;
  box-sizing: border-box;

  span{
    color: #fff;
    font-size: 60px; /*px*/
  }
  .modao-desc{
    font-size: 35px; /*px*/
  }
}

p{
  font-size: 32px; 
  font-family:PingFangSC-Semibold,PingFang SC;
  color:rgba(0,0,0,1);
  // line-height:55px;
  line-height: 1.5;
}
.en-desc-p{
  font-size: 28px;
  display: inline-block;
  // text-align: left;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-weight: 500;
}
.en-service-desc-p{
  text-align: center;
  font-size: 28px;
  display: inline-block;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-weight: 500;
}


.difficult-box{

  .difficult-flex{
    display: flex;
    flex-direction: row;
    justify-content: space-around;


    .difficult-item{
      display: flex;
      flex-direction: column;
      width: 285px;
      height: 350px;
      background-color: #fff;
      box-shadow:6px 4px 15px 0px rgba(0,0,0,0.05);
      border-radius:15px;
      align-items: center;
      justify-content: space-around;
      padding: 35px 0;
      box-sizing: border-box;
      position: relative;

      img{
        object-fit: contain;
        width: 88px;
        height: 88px;
      }

      span{
        font-size: 25px; 
        line-height: 1.2;
        color: #000;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
      }
      .en-diff-title{
        font-size: 20px;
      }

      .description-box{
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #000;
        opacity: 0.7;
        top: 0;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        border-radius: 15px;
        justify-content: space-between;
        padding: 60px 30px 60px;
        box-sizing: border-box;
        
        p{
          color: #fff;
          font-size: 20px; 
          margin: 0;
          line-height: 1.2;
        }
        .en-diff-detail{
          font-size: 18px;
          text-align: left;
          line-height: 1.4;
          // display: inline-block;
          // text-align: justify;
        }
      }
    }
  }
}

.advantage-box{
  padding: 30px 0;

  .serviceAdvantage{
    color: #061E34;
    margin-top: 80px;
    font-size:32px;
  }
  .serviceDesc{
    // margin: auto 280px;
  }

  .advantage-flex{
    display: flex;
    flex-direction: column;

    .advantage-item{
      display: flex;
      flex-direction: row;
      margin: 40px 0;
      justify-content: flex-start;
      padding: 0 200px 0 300px; 
      
      .item-left{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 300px;  /*px*/

        img{
          object-fit: contain;
          width: 80px;
          height: 80px; 
        }

        span{
          font-size: 35px; /*px*/
          line-height: 40px; /*px*/
          color: #000;
          margin-top: 20px;
        }

      }
      .item-right{
        display: flex;
        flex-direction: column;
        text-align: left;
        justify-content: space-around;
        align-items: flex-start;
        padding: 10px 0;
        margin-left: 50px;
        span{
          font-size: 30px; /*px*/
          line-height: 1.2; /*px*/
          color: #000;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
        }

        .en-item-desc{
          font-size: 32px;/*px*/
        }
      }
    }

    .en-item{
      padding-left: 100px;
      padding-right: 0;
    }
  }
}

.apply-box{

  height: 400px; 
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 40px 0;
  box-sizing: border-box;

  .apply-use{
    font-size:35px; 
    font-family:PingFangSC-Medium,PingFang SC;
    color: #061E34;
  }

  .apply-desc{
    font-size:25px; 
    font-family:PingFangSC-Light,PingFang SC;
    color: #000;
  }

  .apply-btn{
    width: 300px;
    height: 70px; 
    font-size: 20px;
    border-radius: 35px;
    color: #fff;
    background-color: #3B86FE;
  }
}


@media only screen and (max-width: 768px) {

  p{
      font-size:20px; /*no*/
      line-height: 25px; /*no*/
  }
  .content-container{
    padding: 30px 30px; /*no*/
  }

  .difficult-box{

    .difficult-flex{

     .difficult-item{
        width:140px;/*no*/
        height: 175px;/*no*/

        img{
          width: 44px;/*no*/
          height: 44px;/*no*/
        }

        span{
          font-size: 15px; /*no*/
        }

        .description-box{
          // position: absolute;
          // width: 100%;
          // height: 100%;
          // background-color: #000;
          // opacity: 0.6;
          // top: 0;
          // bottom: 0;
          // left: 0;
          // display: flex;
          // flex-direction: column;
          // border-radius: 15px;
          // justify-content: space-around;
          // padding: 60px 0 80px;
          // box-sizing: border-box;
          
          p{
            font-size: 15px; /*no*/
          }
        }

      }
    }
  }


  .apply-box{
    height: 200px; /*no*/
    padding: 40px 0;

    .apply-use{
      font-size:20px; /*no*/
    }

    .apply-desc{
      font-size:15px; /*no*/
    }

    .apply-btn{
      width: 150px;/*no*/
      height: 36px; /*no*/
      border-radius: 18px;/*no*/
    }
  }

}

</style>


// WEBPACK FOOTER //
// src/pages/Modao.vue